module.exports = __webpack_public_path__ + "fonts/5ed587dd9bc960eaf8d98530ecee8ad7-Roboto-MediumItalic.eot";